if (typeof window.SectionText3Images === 'undefined') {
  class SectionText3Images {
    constructor(splideContainer) {
      this.splideContainer = splideContainer;
      this.splideList = this.splideContainer?.querySelector('.splide__list');
      this.splideInstance = undefined;
      this.pagination = this.splideContainer?.closest('.container')?.querySelector('.js-text-3-images-pagination');
      this.init();
    }

    init() {
      if (!this.splideContainer || typeof window.Splide === 'undefined') return;
      this.enableSplide();
    }

    enableSplide() {
      if (!this.splideInstance) {
        this.splideInstance = new window.Splide(this.splideContainer, {
          arrows: false,
          type: 'slide',
          perPage: 1,
          gap: '1rem',
          pagination: false,
          duration: 1500,
          dragMinThreshold: 5,
          flickPower: 100,
          mediaQuery: 'min',
          speed: 500,
          easing: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
          breakpoints: {
            1024: {
              destroy: true,
            },
          }
        });
        this.splideInstance.on('mounted move', () => this.updatePagination());
        this.splideInstance.mount();
        this.renderPagination();
        if (this.pagination) {
          this.pagination.addEventListener('click', (e) => {
            if (e.target && e.target.matches('.js-text-3-images-dot')) {
              const idx = parseInt(e.target.dataset.index, 10);
              if (!isNaN(idx)) {
                this.splideInstance.go(idx);
              }
            }
          });
        }
      }
    }

    renderPagination() {
      if (!this.pagination || !this.splideList) return;
      const slides = this.splideList.querySelectorAll('.splide__slide');
      this.pagination.innerHTML = ''; 
      slides.forEach((_, idx) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'js-text-3-images-dot w-full h-[0.125rem] bg-clair/50 aria-selected:bg-clair transition-all';
        dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        dot.setAttribute('data-index', idx);
        dot.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        this.pagination.appendChild(dot);
      });
    }
    
    updatePagination() {
      if (!this.pagination || !this.splideInstance) return;
      const curr = this.splideInstance.index;
      const dots = this.pagination.querySelectorAll('.js-text-3-images-dot');
      dots.forEach((dot, idx) => {
        dot.setAttribute('aria-selected', idx === curr ? 'true' : 'false');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.js-text-3-images-splide').forEach(function(splide) {
      new SectionText3Images(splide);
    });
  });
}


